import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

export function useProjectList() {
  // todo shit
  const { t } = useTranslation("consumption");
  const { data } = useQuery<
    { projectName: string; projectId: number; isMain: number }[]
  >("/api/rendering/task/renderingTask/loadingProjectName");

  data?.forEach((p, idx) => {
    if (p.projectName === "render_project_default_value")
      data[idx].projectName = t("render_project_default_value");
  });

  return data;
}
